import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints";

/**
 * Cihazları çalışan ve cihaz bilgilerine göre sayfalı getirir.
 *
 * @param {{query: {employeeId?: string, isLocationEnabled?: boolean, permissionBgLocation?: string, permissionNotification?: string, isPowerSaving?: boolean, isBatteryOptimizationIgnored?: boolean, permissionFineLocation?: boolean, deviceBrandModel?: string, appVersion?: string, osVersion?: string, page?: number, limit?: number}}} option
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.Device.GetAll(option));
  return ResponseChecker(defaultMessages, response);
};

export default {
  GetAll,
};
